<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    width="100%"
    max-width="360px" 
  >
    <template #activator="{ on }">
      <a style="text-decoration: underline;" v-on="on">Manage your settings</a>
    </template>

    <v-card>
      <v-card-title style="background-color: #004056" class="white--text mb-3">
        Membership
      </v-card-title>

      <v-card-text v-if="complementary">
        <div>
          Your membership is currently complementary.  You don't need to do anything else at this time.
        </div>
      </v-card-text>
    
      <v-card-text v-else>
        <div>
          Your membership  
          <span style="white-space: nowrap">
            {{ valid_through }}
          </span>
        </div>
        
        <v-checkbox 
          label="Auto Renew"
          :input-value="pro.membership_auto_renew"
          @change="onUpdateAutoRenew"
        />
        <div v-if="pro.membership_auto_renew">
          You are set to auto-renew. This enables you to continue to receive new leads from
          your partners and to review your previous leads.
        </div>
        <div v-else class="red--text">
          You are not set to automatically renew. This means you wont be able to receive new leads from your partners.  You will only be able to see your previous leads 90 days after this time.
        </div>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center py-3">
        <v-btn @click="close">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'SubscriptionSupportDialog',

  props: ['pro'],

  data() {
    return {
      dialogVisible: false,
    }
  },

  computed: {
    complementary() {
      return !this.pro.membership_last_valid_time
    },

    missing_card() {
      return this.pro.alerts.includes('payment_method')
    },

    valid_through() {
      const start_of_today = new Date(new Date().toDateString())
      const { membership_last_valid_time } = this.pro

      if (membership_last_valid_time && start_of_today <= new Date(membership_last_valid_time))
        return "expires " + this.formatDate(membership_last_valid_time)
      
      return 'is EXPIRED'
    }
  },
  
  methods: {
    ...mapActions('auth', ['updateAutoRenew']),
    ...formatters,

    close() { 
      this.dialogVisible = false
    },

    onUpdateAutoRenew(auto_renew) {
      this.updateAutoRenew({ auto_renew })  
    },
  },
}
</script>